import { useEffect, useState } from "react";
import { fetchTree } from "../services/categoriesApi";

let cache = null;
let inflight = null;
const subscribers = new Set();

function notify() {
  subscribers.forEach((fn) => fn());
}

async function load() {
  if (inflight) return inflight;
  inflight = fetchTree()
    .then((data) => {
      cache = data;
      inflight = null;
      notify();
      return data;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });
  return inflight;
}

export function invalidateCategoriesTree() {
  cache = null;
  load().catch(() => {});
}

// Convertit le tree API ({_id, slug, children, ...}) au shape attendu
// par les composants legacy (subCategories[].subCat[]). Utilisé par les
// modals AddProduct/EditProduct qui datent d'avant la migration vers
// l'API.
export function treeToLegacyShape(tree) {
  return (tree || []).map((cat) => ({
    ...cat,
    subCategories: (cat.children || []).map((ch) => ({
      ...ch,
      subCat: ch.children || [],
    })),
  }));
}

export default function useCategoriesTree() {
  const [tree, setTree] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const sub = () => {
      if (mounted) setTree(cache || []);
    };
    subscribers.add(sub);
    if (!cache) {
      setLoading(true);
      load()
        .then(() => mounted && setLoading(false))
        .catch((e) => {
          if (mounted) {
            setError(e);
            setLoading(false);
          }
        });
    }
    return () => {
      mounted = false;
      subscribers.delete(sub);
    };
  }, []);

  return { tree, loading, error, refetch: invalidateCategoriesTree };
}
